<template>
  <div class="pro-page auto">
    <div class="imgbox auto"><img :src="url + '/product/elantra_n/pro-img1.jpg'" alt=""></div>

    <div class="pro-menu" ref="column0">
      <img :src="url + '/product/elantra_n/nav-bg.jpg'" class="navbg" alt="">
      <ul class="nav">
        <li @click="scrollTo('column0')">
          <img :src="url + '/product/elantra_n/nav1cur.png'" v-if="curMenu === 0" class="navitemimg" alt="">
          <img :src="url + '/product/elantra_n/nav1.png'" v-else class="navitemimg" alt="">
          <span v-if="curMenu === 0"></span>
        </li>
        <li @click="scrollTo('column1')">
          <img :src="url + '/product/elantra_n/nav2cur.png'" v-if="curMenu === 1" class="navitemimg" alt="">
          <img :src="url + '/product/elantra_n/nav2.png'" v-else class="navitemimg" alt="">
          <span v-if="curMenu === 1"></span>
        </li>
        <li @click="scrollTo('column2')">
          <img :src="url + '/product/elantra_n/nav3cur.png'" v-if="curMenu === 2" class="navitemimg" alt="">
          <img :src="url + '/product/elantra_n/nav3.png'" v-else class="navitemimg" alt="">
          <span v-if="curMenu === 2"></span>
        </li>
        <li @click="scrollTo('column3')">
          <img :src="url + '/product/elantra_n/nav4cur.png'" v-if="curMenu === 3" class="navitemimg" alt="">
          <img :src="url + '/product/elantra_n/nav4.png'" v-else class="navitemimg" alt="">
          <span v-if="curMenu === 3"></span>
        </li>
        <li @click="scrollTo('column4')">
          <img :src="url + '/product/elantra_n/nav5cur.png'" v-if="curMenu === 4" class="navitemimg" alt="">
          <img :src="url + '/product/elantra_n/nav5.png'" v-else class="navitemimg" alt="">
          <span v-if="curMenu === 4"></span>
        </li>
        <li class="more" @click="showSubMenuFn">
          <img :src="url + '/product/elantra_n/pro-menu-icon.png'" class="navicon" alt="">
        </li>
      </ul>
      <div class="subnav" v-if="showSubMenu && scrollTop + 10 < columnObj['0']">
        <div class="subnavarrow auto">
          <img :src="url + '/product/elantra_n/pro-arrow-up.png'" class="navarrow" alt="">
        </div>
        <ul>
          <li @click="scrollTo('column5')">
            <img :src="url + '/product/elantra_n/nav6cur.png'" v-if="curMenu === 5" class="navitemimg" alt="">
            <img :src="url + '/product/elantra_n/nav6.png'" v-else class="navitemimg" alt="">
          </li>
          <li @click="scrollTo('column6')">
            <img :src="url + '/product/elantra_n/nav7cur.png'" v-if="curMenu === 6" class="navitemimg" alt="">
            <img :src="url + '/product/elantra_n/nav7.png'" v-else class="navitemimg" alt="">
          </li>
          <li @click="scrollTo('column7')">
            <img :src="url + '/product/elantra_n/nav8cur.png'" v-if="curMenu === 7" class="navitemimg" alt="">
            <img :src="url + '/product/elantra_n/nav8.png'" v-else class="navitemimg" alt="">
          </li>
        </ul>
      </div>
    </div>
    <div class="pro-menu pro-menu2" v-if="scrollTop + 10 >= columnObj['0']">
      <img :src="url + '/product/elantra_n/nav-bg.jpg'" class="navbg" alt="">
      <ul class="nav">
        <li @click="scrollTo('column0')">
          <img :src="url + '/product/elantra_n/nav1cur.png'" v-if="curMenu === 0" class="navitemimg" alt="">
          <img :src="url + '/product/elantra_n/nav1.png'" v-else class="navitemimg" alt="">
          <span v-if="curMenu === 0"></span>
        </li>
        <li @click="scrollTo('column1')">
          <img :src="url + '/product/elantra_n/nav2cur.png'" v-if="curMenu === 1" class="navitemimg" alt="">
          <img :src="url + '/product/elantra_n/nav2.png'" v-else class="navitemimg" alt="">
          <span v-if="curMenu === 1"></span>
        </li>
        <li @click="scrollTo('column2')">
          <img :src="url + '/product/elantra_n/nav3cur.png'" v-if="curMenu === 2" class="navitemimg" alt="">
          <img :src="url + '/product/elantra_n/nav3.png'" v-else class="navitemimg" alt="">
          <span v-if="curMenu === 2"></span>
        </li>
        <li @click="scrollTo('column3')">
          <img :src="url + '/product/elantra_n/nav4cur.png'" v-if="curMenu === 3" class="navitemimg" alt="">
          <img :src="url + '/product/elantra_n/nav4.png'" v-else class="navitemimg" alt="">
          <span v-if="curMenu === 3"></span>
        </li>
        <li @click="scrollTo('column4')">
          <img :src="url + '/product/elantra_n/nav5cur.png'" v-if="curMenu === 4" class="navitemimg" alt="">
          <img :src="url + '/product/elantra_n/nav5.png'" v-else class="navitemimg" alt="">
          <span v-if="curMenu === 4"></span>
        </li>
        <li class="more" @click="showSubMenuFn">
          <img :src="url + '/product/elantra_n/pro-menu-icon.png'" class="navicon" alt="">
        </li>
      </ul>
      <div class="subnav" v-if="showSubMenu">
        <div class="subnavarrow auto">
          <img :src="url + '/product/elantra_n/pro-arrow-up.png'" class="navarrow" alt="">
        </div>
        <ul>
          <li @click="scrollTo('column5')">
            <img :src="url + '/product/elantra_n/nav6cur.png'" v-if="curMenu === 5" class="navitemimg" alt="">
            <img :src="url + '/product/elantra_n/nav6.png'" v-else class="navitemimg" alt="">
          </li>
          <li @click="scrollTo('column6')">
            <img :src="url + '/product/elantra_n/nav7cur.png'" v-if="curMenu === 6" class="navitemimg" alt="">
            <img :src="url + '/product/elantra_n/nav7.png'" v-else class="navitemimg" alt="">
          </li>
          <li @click="scrollTo('column7')">
            <img :src="url + '/product/elantra_n/nav8cur.png'" v-if="curMenu === 7" class="navitemimg" alt="">
            <img :src="url + '/product/elantra_n/nav8.png'" v-else class="navitemimg" alt="">
          </li>
        </ul>
      </div>
    </div>

    <div class="imgbox auto" ref="column0"><img :src="url + '/product/elantra_n/pro-img2.jpg'" alt=""></div>
    <div class="imgbox swiper-container3 auto">
      <div class="swiper-wrapper">
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img3.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img3-2.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img3-3.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img3-4.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img3-5.jpg'" alt=""></div>
      </div>
      <div class="swiper-pagination">
        <ul>
          <li :class="container3index === 0 && 'cur'"></li>
          <li :class="container3index === 1 && 'cur'"></li>
          <li :class="container3index === 2 && 'cur'"></li>
          <li :class="container3index === 3 && 'cur'"></li>
          <li :class="container3index === 4 && 'cur'"></li>
        </ul>
      </div>
      <div class="swiper-button-prev"><img v-lazy="url + '/product/elantra_n/pro-white-left-arrow.png'" alt=""></div>
      <div class="swiper-button-next"><img v-lazy="url + '/product/elantra_n/pro-white-right-arrow.png'" alt=""></div>
    </div>
    <div class="imgbox auto" ref="column1"><img v-lazy="url + '/product/elantra_n/pro-img4.jpg'" alt=""></div>
    <div class="imgbox auto" ref="column2"><img v-lazy="url + '/product/elantra_n/pro-img5.jpg'" alt=""></div>
    <div class="imgbox swiper-container2 auto">
      <div class="swiper-wrapper">
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img6.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img6-2.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img6-3.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img6-4.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img6-5.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img6-6.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img6-7.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img6-8.jpg'" alt=""></div>
      </div>
      <div class="swiper-pagination">
        <ul>
          <li :class="container2index === 0 && 'cur'"></li>
          <li :class="container2index === 1 && 'cur'"></li>
          <li :class="container2index === 2 && 'cur'"></li>
          <li :class="container2index === 3 && 'cur'"></li>
          <li :class="container2index === 4 && 'cur'"></li>
          <li :class="container2index === 5 && 'cur'"></li>
          <li :class="container2index === 6 && 'cur'"></li>
          <li :class="container2index === 7 && 'cur'"></li>
        </ul>
      </div>
      <div class="swiper-button-prev"><img v-lazy="url + '/product/elantra_n/pro-white-left-arrow.png'" alt=""></div>
      <div class="swiper-button-next"><img v-lazy="url + '/product/elantra_n/pro-white-right-arrow.png'" alt=""></div>
    </div>
    <div class="imgbox swiper-container1 auto" ref="column3">
      <div class="swiper-wrapper">
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img7.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img7-2.jpg'" alt=""></div>
      </div>
      <div class="swiper-pagination">
        <ul>
          <li :class="container1index === 0 && 'cur'"></li>
          <li :class="container1index === 1 && 'cur'"></li>
        </ul>
      </div>
      <div class="swiper-button-prev"><img v-lazy="url + '/product/elantra_n/pro-white-left-arrow.png'" alt=""></div>
      <div class="swiper-button-next"><img v-lazy="url + '/product/elantra_n/pro-white-right-arrow.png'" alt=""></div>
    </div>
    <div class="imgbox auto" ref="column4"><img v-lazy="url + '/product/elantra_n/pro-img8.jpg'" alt=""></div>
    <div class="imgbox auto"><img v-lazy="url + '/product/elantra_n/pro-img9.jpg'" alt=""></div>
    <div class="imgbox auto"><img v-lazy="url + '/product/elantra_n/pro-img10.jpg'" alt=""></div>
    <div class="imgbox auto" ref="column5"><img v-lazy="url + '/product/elantra_n/pro-img11.jpg'" alt=""></div>
    <div class="imgbox swiper-container-card auto">
      <div class="swiper-wrapper">
        <div class="swiper-slide"><img :src="url + '/product/elantra_n/pro-img12.jpg'" alt=""></div>
        <div class="swiper-slide"><img :src="url + '/product/elantra_n/pro-img12-2.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img12-3.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img12-4.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img12-5.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img12-6.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img12-7.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img12-8.jpg'" alt=""></div>
        <div class="swiper-slide"><img :src="url + '/product/elantra_n/pro-img12-9.jpg'" alt=""></div>
      </div>
    </div>
    <div class="imgbox auto" ref="column6"><img v-lazy="url + '/product/elantra_n/pro-img13.jpg'" alt=""></div>
    <div class="imgbox swiper-container-card2 auto">
      <div class="swiper-wrapper">
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img14.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img14-2.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img14-3.jpg'" alt=""></div>
      </div>
      <div class="swiper-button-prev"><img v-lazy="url + '/product/elantra_n/pro-white-left-arrow.png'" alt=""></div>
      <div class="swiper-button-next"><img v-lazy="url + '/product/elantra_n/pro-white-right-arrow.png'" alt=""></div>
    </div>
    <div class="imgbox auto" ref="column7"><img v-lazy="url + '/product/elantra_n/pro-img15.jpg'" alt=""></div>
    <div class="imgbox scrollbox auto">
      <div class="swiper-wrapper">
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img16.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img16-2.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img16-3.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img16-4.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img16-5.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img16-6.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img16-7.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img16-8.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img16-9.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img16-10.jpg'" alt=""></div>
        <div class="swiper-slide"><img v-lazy="url + '/product/elantra_n/pro-img16-11.jpg'" alt=""></div>
      </div>
    </div>
    <div class="imgbox auto"><img v-lazy="url + '/product/elantra_n/pro-img17.jpg'" alt=""></div>
  </div>
</template>

<script>
import Swiper from 'swiper';
export default {
  data () {
    return {
      container1index: 0,
      container2index: 0,
      container3index: 0,
      showSubMenu: false,
      curMenu: 0,
      columnObj: {
        '0': 800,
        '1': 0,
        '2': 0,
        '3': 0,
        '4': 0,
        '5': 0,
        '6': 0,
        '7': 0
      },
      scrollTop: 0,
      url: 'https://elantran-cnd.vintro.cn/elantra_n_client_activity/images'
    }
  },
  methods: {
    showSubMenuFn () {
      this.showSubMenu = !this.showSubMenu
    },
    scrollTo (obj) {
      let dom = this.$refs[obj]
      dom.scrollIntoView({
        behavior: "smooth", // 定义动画过渡效果， "auto"或 "smooth" 。默认为 "auto"。
        block: "start", // 定义垂直方向的对齐， "start", "center", "end", 或 "nearest"。默认为 "start"。
        inline: "nearest", // 定义水平方向的对齐， "start", "center", "end", 或 "nearest"。默认为 "nearest"
      })
    }
  },
  mounted(){
    this.$nextTick(() => {
      console.log(this.$refs['column1'].offsetTop)
      console.log(this.$refs['column2'].offsetTop)
    })

    this.$wx.miniProgram.getEnv((res)=>{
      if (res.miniprogram) {
        // alert("在小程序里");
        this.$wx.miniProgram.postMessage({
          data: {
            title: '全新ELANTRA N'
          }
        })
      }
    })

    window.addEventListener('scroll', () => {
      // console.log('scrollTop', document.documentElement.scrollTop);
      // console.log('column0', this.$refs['column0'].offsetTop)
      // console.log('column1', this.$refs['column1'].offsetTop)
      // console.log('column2', this.$refs['column2'].offsetTop)
      // console.log('column3', this.$refs['column3'].offsetTop)
      // console.log('column4', this.$refs['column4'].offsetTop)
      // console.log('column5', this.$refs['column5'].offsetTop)
      // console.log('column6', this.$refs['column6'].offsetTop)
      // console.log('column7', this.$refs['column7'].offsetTop)
      this.scrollTop = document.documentElement.scrollTop

      if (this.columnObj['7'] < 800) {
        this.columnObj['0'] = this.$refs['column0'].offsetTop
        this.columnObj['1'] = this.$refs['column1'].offsetTop
        this.columnObj['2'] = this.$refs['column2'].offsetTop
        this.columnObj['3'] = this.$refs['column3'].offsetTop
        this.columnObj['4'] = this.$refs['column4'].offsetTop
        this.columnObj['5'] = this.$refs['column5'].offsetTop
        this.columnObj['6'] = this.$refs['column6'].offsetTop
        this.columnObj['7'] = this.$refs['column7'].offsetTop
        // console.log(this.$refs['column1'].offsetTop)
      }

      if (this.scrollTop < this.columnObj['0'] + 10) {
        this.curMenu = 0
      } else if (this.scrollTop < this.columnObj['1'] + 10) {
        this.curMenu = 1
      } else if (this.scrollTop < this.columnObj['2'] + 10) {
        this.curMenu = 2
      } else if (this.scrollTop < this.columnObj['3'] + 10) {
        this.curMenu = 3
      } else if (this.scrollTop < this.columnObj['4'] + 10) {
        this.curMenu = 4
      } else if (this.scrollTop < this.columnObj['5'] + 10) {
        this.curMenu = 5
      } else if (this.scrollTop < this.columnObj['6'] + 10) {
        this.curMenu = 6
      } else if (this.scrollTop < this.columnObj['7'] + 10) {
        this.curMenu = 7
      }
      // console.log('curMenu', this.curMenu)
    });

    var _that = this
    new Swiper ('.swiper-container', {
      loop: true,
      // 如果需要分页器
      pagination: '.swiper-pagination',
      // 如果需要前进后退按钮
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      // 如果需要滚动条
      scrollbar: '.swiper-scrollbar',
    })

    
    var swiper1 = new Swiper ('.swiper-container1', {
      loop: false,
      // 如果需要分页器
      pagination: '.swiper-pagination',
      on:{
        transitionEnd: function(){
          _that.container1index = swiper1.activeIndex
          console.log(swiper1.activeIndex)
        }
      }
    })

    
    var swiper2 = new Swiper ('.swiper-container2', {
      loop: false,
      // 如果需要分页器
      pagination: '.swiper-pagination',
      on:{
        transitionEnd: function(){
          _that.container2index = swiper2.activeIndex
          console.log(swiper2.activeIndex)
        }
      }
    })

    
    var swiper3 = new Swiper ('.swiper-container3', {
      loop: false,
      // 如果需要分页器
      pagination: '.swiper-pagination',
      on:{
        transitionEnd: function(){
          _that.container3index = swiper3.activeIndex
          console.log(swiper3.activeIndex)
        }
      }
    })

    
    new Swiper ('.swiper-container-card', {
      loop: true,
      paginationClickable: true,
      centeredSlides: true,
      slidesPerView: 2,
      initialSlide: 0,
      watchActiveIndex: true
    })

    
    new Swiper ('.swiper-container-card2', {
      loop: false,
      paginationClickable: true,
      centeredSlides: true,
      slidesPerView: 1.7,
      initialSlide: 0,
      watchActiveIndex: true,
      // nextButton: '.swiper-button-next',
      // prevButton: '.swiper-button-prev',
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // }
    })
  }
}
</script>

<style lang="scss" scoped>
.pro-page {
  background: #000;
}
.scrollbox {
  width: 100vw;
  background: #2a2a2a;
  overflow-x: auto;
  .swiper-wrapper {
    width: calc(83.53vw * 11);
    .swiper-slide {
      float: left;
      width: 78.53vw;
      margin-right: 5vw;
    }
  }
}
.swiper-container-card {
  background: #2a2a2a;
  height: 114.13vw;
  .swiper-wrapper {
    align-items: center;
  }
  .swiper-slide-prev {
    img {
      height: 90.8vw;
      width: auto;
      position: absolute;
      left: -36vw;
      top: 5vw;
    }
  }
  .swiper-slide-active {
    z-index: 9;
    img {
      height: 100.66vw;
      width: auto;
      position: absolute;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
    }
  }
  .swiper-slide-next {
    img {
      height: 90.8vw;
      width: auto;
      position: absolute;
      right: -36vw;
      top: 5vw;
    }
  }
}
.swiper-container-card2 {
  // background: #2a2a2a;
  position: relative;
  height: 88vw;
  .swiper-slide {
    // margin-right: 17vw;
    img {
      position: absolute;
      // top: 0;
      left: -13vw;
      height: auto;
      width: 56vw;
    }
  }
  .swiper-button-prev {
    position: absolute;
    left: 2vw;
    top: 40%;
    z-index: 9;
    img {
      width: 3vw;
    }
  }
  .swiper-button-next {
    position: absolute;
    right: 2vw;
    top: 40%;
    z-index: 9;
    img {
      width: 3vw;
    }
  }
}

.swiper-container1 {
  position: relative;
  .swiper-pagination {
    position: absolute;
    left: 0;
    bottom: 5vw;
    z-index: 9;
    width: 100%;
    text-align: center;
    ul {
      li {
        display: inline-block;
        width: 2.2vw;
        height: 2.2vw;
        overflow: hidden;
        border-radius: 2.2vw;
        background: #fff;
        margin: 0 1.2vw;
      }
      li.cur {
        background: #e63312;
      }
    }
  }
  .swiper-button-prev {
    position: absolute;
    left: 2vw;
    top: 26%;
    z-index: 9;
    img {
      width: 3vw;
    }
  }
  .swiper-button-next {
    position: absolute;
    right: 2vw;
    top: 26%;
    z-index: 9;
    img {
      width: 3vw;
    }
  }
}

.swiper-container2 {
  position: relative;
  .swiper-pagination {
    position: absolute;
    left: 0;
    bottom: 7vw;
    z-index: 9;
    width: 100%;
    text-align: center;
    ul {
      li {
        display: inline-block;
        width: 2.2vw;
        height: 2.2vw;
        overflow: hidden;
        border-radius: 2.2vw;
        background: #fff;
        margin: 0 1.2vw;
      }
      li.cur {
        background: #e63312;
      }
    }
  }
  .swiper-button-prev {
    position: absolute;
    left: 2vw;
    top: 26%;
    z-index: 9;
    img {
      width: 3vw;
    }
  }
  .swiper-button-next {
    position: absolute;
    right: 2vw;
    top: 26%;
    z-index: 9;
    img {
      width: 3vw;
    }
  }
}

.swiper-container3 {
  position: relative;
  .swiper-pagination {
    position: absolute;
    left: 0;
    bottom: 5vw;
    z-index: 9;
    width: 100%;
    text-align: center;
    ul {
      li {
        display: inline-block;
        width: 2.2vw;
        height: 2.2vw;
        overflow: hidden;
        border-radius: 2.2vw;
        background: #fff;
        margin: 0 1.2vw;
      }
      li.cur {
        background: #e63312;
      }
    }
  }
  .swiper-button-prev {
    position: absolute;
    left: 2vw;
    top: 26%;
    z-index: 9;
    img {
      width: 3vw;
    }
  }
  .swiper-button-next {
    position: absolute;
    right: 2vw;
    top: 26%;
    z-index: 9;
    img {
      width: 3vw;
    }
  }
}

.pro-menu {
  width: 100%;
  position: relative;
  z-index: 10;
  .nav {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    li {
      display: flex;
      align-items: center;
      position: relative;
      span {
        position: absolute;
        width: 100%;
        height: 0.3em;
        background: #e63312;
        left: 0;
        bottom: 0;
      }
    }
    .more {
      width: 16vw;
      align-items: center;
      justify-content: center;
      img {
        width: 1.33vw;
        height: 5.2vw;
      }
    }
  }
  .subnav {
    position: absolute;
    right: 0;
    top: 100%;
    .subnavarrow {
      text-align: right;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
    }
    .navarrow {
      width: 7vw;
    }
    ul {
      display: block;
      width: 27.46vw;
      background: #fff;
      padding: 2.26vw 0 3.46vw;
      li {
        width: 21.46vw;
        margin: 0 auto;
        border-bottom: 1px solid rgba(142, 142, 142, .43);
      }
      li:last-child {
        border-bottom: none;
      }
    }
  }
}
.pro-menu2 {
  position: fixed;
  left: 0;
  top: 0;
}
</style>